import React from 'react';
import classNames from 'classnames';

export interface IABSImageProps {
  logo: string;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  alt?: string;
  title?: string;
  onClick?: (enent: any) => void;
  className?: string;
}
class ABSImage extends React.Component<IABSImageProps> {
  render() {
    const { logo, width, height, style, alt, title, onClick, className } = this.props;
    const classes = classNames('abs-img', className);
    return (
      <div className={classes}>
        <img
          className="img"
          style={{ ...style }}
          src={logo}
          width={width}
          height={height}
          alt={alt}
          title={title}
          onClick={onClick}
        />
      </div>
    );
  }
}

export default ABSImage;  


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSImage/index.tsx